import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import LazyBackgroundImage from "../LazyBackgroundImage";

import "./index.css";

gsap.registerPlugin(ScrollTrigger);

const Bio = () => {
  const aboutRef = useRef(null);

  useEffect(() => {
    gsap.to(".bio-image-column", {
      opacity: 0.1,
      duration: 1.5,
      borderTopLeftRadius: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: aboutRef.current,
        start: "top 40%",
        end: "bottom 20%",
        toggleActions: "play reverse play reverse",
        once: true,
      },
    });
  }, []);

  return (
    <section ref={aboutRef} id="about" className="bio-container">
      <LazyBackgroundImage 
        src={require("./img/9.jpg")} 
        className="bio-column bio-image-column"
        isHero={false}
      />
      <div className="bio-column bio-text-column">
        <div className="bio-text-column-inner">
          <p className="bio-text">
            She most recently directed
            <span className="bio-text-heightened"> ABOUT MY FATHER</span>{" "}
            for Lionsgate, starring Robert De Niro, Kim Cattrall and Sebastian
            Maniscalco with Depth of Field producing.
          </p>
          <p className="bio-text">
            Only three other women have ever directed De Niro in a live-action
            film over his 60-year career: Nancy Meyers, Penny Marshall and
            Agnès Varda.
          </p>
          <p className="bio-text">
            Before that, Laura directed the Netflix film
            <span className="bio-text-heightened"> WORK IT</span>{" "}
            starring Sabrina Carpenter, Jordan Fisher and Liza Koshy. The film
            premiered worldwide as the #1 movie on Netflix and was well
            received by critics and audiences alike.
          </p>
          <p className="bio-text">
            She is the co-writer and co-producer of the film
            <span className="bio-text-heightened"> HELLO, MY NAME IS DORIS</span>,
            directed by Michael Showalter and starring Sally Field. The
            feature is based on her short film
            <span className="bio-text-heightened"> DORIS & THE INTERN</span>.
            Released by Roadside Attractions, the film was one of the
            highest-grossing indies of 2016.
          </p>
          <p className="bio-text">
            Prior to WORK IT, Laura co-wrote and directed the feature
            <span className="bio-text-heightened"> GOOD GIRLS GET HIGH</span>,
            produced by Alloy Entertainment for Warner Blue Ribbon. It
            premiered to a sold-out crowd at the 2018 Los Angeles Film
            Festival and won the Audience Award at the Santa Fe Film Festival.
            The film was purchased by DirecTV in 2019.
          </p>
          <p className="bio-text">
            Her indie feature debut as writer/director/producer
            <span className="bio-text-heightened"> FITS AND STARTS</span>{" "}
            starred Wyatt Cenac and Greta Lee and premiered at the 2017 SXSW
            Film Festival and went on to screen at the AFI Film Festival among many others.
          </p>
          <p className="bio-text">
            She studied at the Graduate Film Program at NYU.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Bio;
